import { render } from "./SupplierPrez.vue?vue&type=template&id=211b0b12&scoped=true"
import script from "./SupplierPrez.vue?vue&type=script&lang=js"
export * from "./SupplierPrez.vue?vue&type=script&lang=js"

import "./SupplierPrez.vue?vue&type=style&index=0&id=211b0b12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211b0b12"]])

export default __exports__